import { app } from "..";

export function resolveAssetUrl(assetId: string, access: 'public' | 'private' = 'private'): string {
    if (access === 'private') {
        return `https://cdn-lakshya-app-private-assets.lakshyakerala.app/application/pdf/${assetId}.pdf`;
    } else {
        return `https://cdn-lakshya-app-public-assets.lakshyakerala.app/${assetId}`;
    }
}